import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { useContractCreateMutation } from 'generated/graphql';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import ContractForm from './ContractForm';
import { updateCacheOnCreate } from './lib';

type FormData = {
  startOn: string;
  endOn: string;
  eSign: boolean;
  locationId: string;
  suite: number;
  baseRent: string;
  securityDeposit: string;
  weeklyRent: string;
};

function NewContract() {
  const { clientId } = useParams() as { clientId: string };
  const navigate = useNavigate();
  const goBack = () => navigate('..');
  const form = useForm<FormData>({ defaultValues: { eSign: true } });
  const [createContract, { loading }] = useContractCreateMutation({
    update: updateCacheOnCreate(clientId),
    onCompleted: goBack,
  });

  const onSubmit = form.handleSubmit(({ eSign, ...data }) =>
    createContract({ variables: { data: { ...data, clientId }, options: { skipEsign: !eSign } } })
  );

  return (
    <RoutableModal
      title="New Contract"
      buttons={{ action: { text: 'Save', handler: onSubmit } }}
      loading={loading}
    >
      <Text mb={10}>
        Please enter the required information to create a contract for this client and send them a
        link to eSign the Documents
      </Text>
      <FormProvider {...form}>
        <ContractForm />
      </FormProvider>
    </RoutableModal>
  );
}
export default NewContract;
